import advertiserSettlementsService, { ENDPOINTS } from '@/services/advertiserSettlementsService';
import moduleFactory from '@/store/modules/moduleFactory';

const moduleStore = moduleFactory.build(ENDPOINTS, advertiserSettlementsService);

export default {
    namespaced: true,
    state: {
        ...moduleStore.state,
    },
    getters: {
        ...moduleStore.getters,
    },
    mutations: {
        ...moduleStore.mutations,
    },
    actions: {
        ...moduleStore.actions,
    },
};
